import md5 from 'md5';
import { useCompanyCanonicalUrl } from '@/hooks/useCompany';
import { useMobileDetect } from '@/hooks/useMobileDetect';

export type RegisterModalVariant =
  | 'control'
  | 'earlierFullReport'
  | 'fixedHeight'
  | 'viewportAndHeight';
//Register modal activation variants for company split:
// '8','9' -> control
// 'a','b' -> click and scroll experiment
// 'c','d' -> fixed height (at 1600px) experiment
// 'e','f' -> viewport + height experiment
export function getRegisterModalVariant(
  canonicalUrl: string
): RegisterModalVariant {
  // Not running the experiment on native
  if (RUNTIME_ENV === 'native') return 'control';
  if (!canonicalUrl) return 'control';

  const hash: string = md5(canonicalUrl);
  // This value is a hexadecimal: 0,1,2,3,4,5,6,7, 8,9,a,b,c,d,e,f
  const least = hash.slice(hash.length - 1);

  if (Number(least) < 8) {
    // URL must be part of the Split Variant. In order words, the last character must be greater than or equal to 8 in hexadecimal
    throw new Error('canonicalUrl must be a Split variant');
  }

  let variant: RegisterModalVariant = 'control';
  if (least === 'a' || least === 'b') variant = 'earlierFullReport';
  if (least === 'c' || least === 'd') variant = 'fixedHeight';
  if (least === 'e' || least === 'f') variant = 'viewportAndHeight';
  return variant;
}

export function useRegisterModalVariantDetect(): RegisterModalVariant {
  const isMobile = useMobileDetect();
  const canonicalUrl = useCompanyCanonicalUrl();
  if (isMobile) return 'control';

  return getRegisterModalVariant(canonicalUrl);
}
